export const LegalStatusModel = Symbol.for('LegalStatusModel');
